/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CodeRuntime,
  CodeRuntime$inboundSchema,
  CodeRuntime$outboundSchema,
} from "./coderuntime.js";

export type CodeRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  runtime?: CodeRuntime | undefined;
  code: string;
  cwd?: string | null | undefined;
  env?: { [k: string]: string } | undefined;
  timeoutSeconds?: number | undefined;
};

/** @internal */
export const CodeRequest$inboundSchema: z.ZodType<
  CodeRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  runtime: CodeRuntime$inboundSchema.optional(),
  code: z.string(),
  cwd: z.nullable(z.string()).optional(),
  env: z.record(z.string()).optional(),
  timeout_seconds: z.number().int().default(60),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "timeout_seconds": "timeoutSeconds",
  });
});
/** @internal */
export type CodeRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  runtime?: string | undefined;
  code: string;
  cwd?: string | null | undefined;
  env?: { [k: string]: string } | undefined;
  timeout_seconds: number;
};

/** @internal */
export const CodeRequest$outboundSchema: z.ZodType<
  CodeRequest$Outbound,
  z.ZodTypeDef,
  CodeRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  runtime: CodeRuntime$outboundSchema.optional(),
  code: z.string(),
  cwd: z.nullable(z.string()).optional(),
  env: z.record(z.string()).optional(),
  timeoutSeconds: z.number().int().default(60),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    timeoutSeconds: "timeout_seconds",
  });
});

export function codeRequestToJSON(codeRequest: CodeRequest): string {
  return JSON.stringify(CodeRequest$outboundSchema.parse(codeRequest));
}
export function codeRequestFromJSON(
  jsonString: string,
): SafeParseResult<CodeRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CodeRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CodeRequest' from JSON`,
  );
}
